/* eslint-disable */

const { parseAsync } = require('json2csv')
const saveAs = require('file-saver').saveAs
const papa = require('papaparse')

function s2ab(s: any) {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
  return buf
}

export async function json2csv(fields: string[], data: any, fileName: string) {
  const opts = { fields }
  const csv = await parseAsync(data, opts)
  saveAs(new Blob([s2ab(csv)], { type: 'application/octet-stream' }), fileName)
}

// export async function csv2json(file: Fole) {
//   papa.parse(file, config)
// }

export function table2CSV(tableId: string, fileName: string) {
  let data = ''
  const tableData = []
  const rows = document.querySelectorAll(`table#${tableId} tr`)
  for (const row of rows) {
    const rowData = []
    for (const [index, column] of row.querySelectorAll('th, td').entries()) {
      // To retain the commas in the "Description" column, we can enclose those fields in quotation marks.
      if ((index + 1) % 3 === 0) {
        rowData.push('"' + (column as any).innerText + '"')
      } else {
        rowData.push((column as any).innerText)
      }
    }
    tableData.push(rowData.join(','))
  }
  data += tableData.join('\n')
  const a = document.createElement('a')
  a.href = URL.createObjectURL(new Blob([data], { type: 'text/csv' }))
  a.setAttribute('download', fileName)
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
